import React, {useState, useContext} from "react"
import Card from "react-bootstrap/Card"
import providerGet from "graphql/Storage/Provider/query/providerGet"
import {useQuery, useMutation} from "@apollo/client"
import {CodeMirror} from "components/backoffice/CodeMirror/CodeMirror"


// import {Controlled as CodeMirror} from 'react-codemirror2'
// import 'codemirror/mode/javascript/javascript';
// import 'codemirror/lib/codemirror.css';
// import 'codemirror/theme/material.css';

import providerEdit from "graphql/Storage/Provider/mutation/providerEdit"
import providerAdd from "graphql/Storage/Provider/mutation/providerAdd"
import {alertContext} from "context/Alert/alert"

import "./style.scss"
import {GdriveOptions} from "./Gdrive/GdriveOptions"
import {S3Options} from "./S3/S3Options"

type ProviderEditProps = {
  id?: string,
  open?: boolean,
}

export const ProviderEdit = (props: ProviderEditProps) => {

  const {id, open} = props
  const {setMessage, setError} = useContext(alertContext)

  const [isOpen, updateIsOpen] = useState(open || false)
  const [providerValue, updateProviderValue] = useState(null)
  const [valueUpdated, updateValueUpdated] = useState(!id)

  const updateMutation = useMutation(providerEdit)
  const addMutation = useMutation(providerAdd)

  const {data} = useQuery(providerGet, {
    skip: !id,
    variables: {
      id,
    },
    onCompleted: (data) => {
      const provider = data?.provider
      // const optionsStringified = provider?.options && JSON.stringify(provider?.options) || ""
      updateProviderValue({
        ...provider,
        enableScan: (provider?.enableScan) ? "1" : "0",
        // options: optionsStringified,
        options: provider?.options,
      })
      updateValueUpdated(false)
    }
  })

  const originalProvider = {
    ...data?.provider,
    options: data?.provider?.options,
  }

  const onChange = (provider: any) => {
    updateValueUpdated(true)
    updateProviderValue(provider)
  }

  const resetChange = () => {
    updateProviderValue(originalProvider)
    updateValueUpdated(false)
  }

  const saveChanges = () => {
    if (id) {
      const {id, __typename, ...rest} = providerValue
      updateMutation[0]({
        variables: {
          id,
          input: {
            ...rest,
            enableScan: (providerValue?.enableScan === "1") ? true : false,
            // options: JSON.parse(providerValue?.options),
          }
        }
      })
        .then(() => {
          setMessage("Provider enregistré")
          updateValueUpdated(false)
        })
        .catch(() => setError("Impossible d'enregistrer le provider"))
    } else {
      addMutation[0]({
        variables: {
          input: {
            ...providerValue,
            enableScan: (providerValue?.enableScan === "1") ? true : false,
            // options: JSON.parse(providerValue?.options),
          }
        }
      })
        .then(() => {
          setMessage("Provider ajouté")
          updateValueUpdated(false)
        })
        .catch(() => setError("Impossible d'ajouter le provider"))
    }
  }

  const _renderOptions = (type: string, value: any) => {
    switch (type) {
      case "GDRIVE": {
        return <GdriveOptions
          options={value}
          onChange={(value: any) => {
            onChange({
              ...providerValue,
              options: value,
            })
          }}
        />
      }
      case "S3": {
        return <S3Options
          options={value}
          onChange={(value: any) => {
            onChange({
              ...providerValue,
              options: value,
            })
          }}
        />
      }
      default: {
        const optionsStringified = providerValue?.options && JSON.stringify(providerValue?.options)
        return <CodeMirror
          value={optionsStringified}
          onChange={(value) => console.log(value)}
        />
      }
    }
  }

  return <div className="provider-edit-container">
    <Card>
      {id && <button type="button" className="provider-card-summary" onClick={() => updateIsOpen(!isOpen)} aria-expanded={isOpen}>
        <span className={`provider-type-icon fas ${providerValue?.type === "S3" ? "fa-cloud" : "fa-hdd"}`} aria-hidden="true"></span>
        <span className="provider-summary-copy">
          <strong>{providerValue?.name || "Chargement…"}</strong>
          <small>{providerValue?.type || "Provider"} · {providerValue?.target === "SOURCE" ? "Source" : "Média"}</small>
        </span>
        <span className={`provider-scan-state ${providerValue?.enableScan === "1" ? "is-enabled" : ""}`}><span></span>{providerValue?.enableScan === "1" ? "Scan actif" : "Scan inactif"}</span>
        <span className={`fas fa-chevron-${isOpen ? "up" : "down"}`} aria-hidden="true"></span>
      </button>}
      <div className={isOpen ? "collapse-container collapse-visible" : "collapse-container"}>
        <Card.Body>
          <div>
            <div className="input-group">
              <span className="input-group-text">Nom</span>
              <input className="form-control" type="text" value={providerValue?.name || ""} onChange={e => onChange({
                ...providerValue,
                name: e.target.value,
              })} />
            </div>
            <div className="input-group">
              <span className="input-group-text">Type</span>
              <select className="form-control" value={providerValue?.type || ""} onChange={e => onChange({
                ...providerValue,
                type: e.target.value,
              })}>
                <option value="" disabled>Choisissez un type</option>
                <option value="GDRIVE">GDRIVE</option>
                <option value="S3">S3</option>
              </select>
            </div>
            <div className="input-group">
              <span className="input-group-text">Scan automatique</span>
              <select className="form-control" value={providerValue?.enableScan} onChange={e => onChange({
                ...providerValue,
                enableScan: e.target.value,
              })}>
                <option value="" disabled>Choisissez un type</option>
                <option value="0">Non</option>
                <option value="1">Oui</option>
              </select>
            </div>
            <div className="input-group">
              <span className="input-group-text">Destination</span>
              <select className="form-control" value={providerValue?.target || ""} onChange={e => onChange({
                ...providerValue,
                target: e.target.value,
              })}>
                <option value="" disabled>Choisissez une cible</option>
                <option value="MEDIA">MEDIA</option>
                <option value="SOURCE">SOURCE</option>
              </select>
            </div>
            <div>
              {_renderOptions(providerValue?.type, providerValue?.options)}
            </div>
            {valueUpdated && <div className="provider-form-actions">
              <button className="bo-primary-action" type="button" onClick={saveChanges}><span className="fas fa-save"></span>Enregistrer</button>
              {id && <button className="bo-secondary-action" type="button" onClick={resetChange}>Annuler</button>}
            </div>}
          </div>
        </Card.Body>
      </div>
    </Card>
  </div>
}
